import { Controller } from "@hotwired/stimulus"

// Fills the feedback form's hidden fields with the screen it was written on,
// so a report of "the button is cut off" arrives with the size it was cut at.
export default class extends Controller {
  static targets = [ "screen_w", "screen_h", "viewport_w", "viewport_h", "touch" ]

  connect() {
    const values = {
      screen_w: window.screen?.width,
      screen_h: window.screen?.height,
      viewport_w: window.innerWidth,
      viewport_h: window.innerHeight,
      touch: (navigator.maxTouchPoints || 0) > 0
    }
    for (const [ name, value ] of Object.entries(values)) {
      const field = this.targets.find(name)
      if (field && value !== undefined) field.value = String(value)
    }
  }
}
